'use client';
import React from 'react';
import { Paper, Button, Text, Group, Box } from '@mantine/core';
import useSafeTranslation from '@/hooks/useSafeTranslation';
import { safeGetItem, safeSetItem } from '@/lib/browserStorage';

const COOKIE_KEY = 'wsc_cookie_consent_v1';

export default function CookieBanner() {
  const { tSafe: t } = useSafeTranslation();
  const [accepted, setAccepted] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    try {
      const v = safeGetItem(COOKIE_KEY);
      setAccepted(v === '1' ? true : v === '0' ? false : null);
    } catch (e) {
      setAccepted(null);
    }
  }, []);

  if (accepted === true) {
    return null;
  }

  const accept = () => {
    try {
      safeSetItem(COOKIE_KEY, '1');
    } catch (e) {
      // ignore
    }
    setAccepted(true);
  };

  const decline = () => {
    try {
      safeSetItem(COOKIE_KEY, '0');
    } catch (e) {
      // ignore
    }
    setAccepted(false);
  };

  return (
    <Box pos="fixed" left={16} right={16} bottom={16}>
      <Paper withBorder shadow="md" radius="xl" p="sm">
        <Group justify="space-between" align="center" gap="sm" wrap="wrap">
          <Text size="sm" flex={1}>
            {t('cookiesBannerText', {
              defaultValue:
                'Este sitio usa una cookie para recordar tu elección sobre cookies y guarda datos localmente en tu navegador. No se envía información a servidores.',
            })}
          </Text>

          <Group gap="sm">
            <Button variant="outline" onClick={decline} aria-label="Rechazar cookies">
              Rechazar
            </Button>
            <Button color="green" onClick={accept} aria-label="Aceptar cookies">
              Aceptar
            </Button>
          </Group>
        </Group>
      </Paper>
    </Box>
  );
}
